import React from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface LanguageSwitcherProps {
  color?: 'inherit' | 'primary';
}

export const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ color = 'primary' }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const { i18n, t } = useTranslation();
  const currentLanguage = i18n.resolvedLanguage?.startsWith('fr') ? 'fr' : 'en';

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelectLanguage = (language: 'en' | 'fr') => {
    void i18n.changeLanguage(language);
    handleClose();
  };

  return (
    <>
      <Button
        color={color}
        variant="outlined"
        onClick={handleOpen}
        sx={{
          minWidth: 58,
          borderRadius: 1.5,
          px: 1.25,
          borderColor: 'divider',
          bgcolor: color === 'inherit' ? 'rgba(255,250,245,0.64)' : 'transparent',
        }}
      >
        {currentLanguage.toUpperCase()}
      </Button>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem selected={currentLanguage === 'en'} onClick={() => handleSelectLanguage('en')}>
          {t('common.languages.en')}
        </MenuItem>
        <MenuItem selected={currentLanguage === 'fr'} onClick={() => handleSelectLanguage('fr')}>
          {t('common.languages.fr')}
        </MenuItem>
      </Menu>
    </>
  );
};

export default LanguageSwitcher;